module.exports = __webpack_public_path__ + "img/es-pc-s6.bfbbe33e.png";